/* eslint-disable react/jsx-props-no-spreading */
import { Flex, TabProps, useMultiStyleConfig, useTab } from '@chakra-ui/react';

interface LearnerDashboardCustomTabProps extends TabProps {
  scrollToTop?: boolean;
}

export default function LearnerDashboardCustomTab(props: LearnerDashboardCustomTabProps) {
  const { scrollToTop = false, ...cleanProps } = props;
  const tabProps = useTab(cleanProps);
  const isSelected = !!tabProps['aria-selected'];
  const styles = useMultiStyleConfig('Tabs', tabProps);

  const { children } = cleanProps;

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    // Call the original onClick if it exists
    if (tabProps.onClick) {
      tabProps.onClick(e);
    }

    if (scrollToTop) {
      // Find the scrollable content container and scroll it to the top
      setTimeout(() => {
        const contentContainer = document.querySelector('[data-content-container="true"]');
        if (contentContainer) {
          contentContainer.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <Flex
      __css={{
        ...styles.tab,
        cursor: 'pointer',
        backgroundColor: isSelected ? 'brand.primary' : 'transparent',
        color: 'neutral.900',
        borderRadius: '100px',
        paddingY: 2,
        paddingX: 4,
        fontSize: { base: '12px', md: '14px' },
        fontWeight: 600,
        border: '1px solid',
        borderColor: 'neutral.200',
        marginY: 1,
        marginRight: 2,
        transition: 'background-color 400ms',
        _hover: {
          color: 'neutral.900',
          backgroundColor: 'neutral.50',
        },
        _selected: {
          color: 'white',
          borderColor: 'none',
          _hover: {
            color: 'white',
            backgroundColor: 'brand.primary',
          },
        },
      }}
      {...tabProps}
      onClick={handleClick}
    >
      {children}
    </Flex>
  );
}
